<ng-template #modalTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ title }}</h4>
  </div>
  <div class="modal-body box-parent">
    <div class="row">
      <div class="col">
        <div class="form-label-group">
          <input type="text"
              id="product-id"
              class="form-control"
              [(ngModel)]="productId"
              placeholder="{{'PRODUCT.LIST.FILTER.PRODUCT-ID' | translate}}">
          <label for="product-id">{{'PRODUCT.LIST.FILTER.PRODUCT-ID' | translate}}</label>
        </div>
        <div class="form-label-group">
          <input type="text"
              id="name-en"
              class="form-control"
              [(ngModel)]="productNameEng"
              placeholder="{{'PRODUCT.LIST.FILTER.PRODUCT-NAME' | translate}} (EN)">
          <label for="name-en">{{'PRODUCT.LIST.FILTER.PRODUCT-NAME' | translate}} (EN)</label>
        </div>
        <div class="form-label-group">
          <input type="text"
              id="name-th"
              class="form-control"
              [(ngModel)]="productNameThai"
              placeholder="{{'PRODUCT.LIST.FILTER.PRODUCT-NAME' | translate}} (TH)">
          <label for="name-th">{{'PRODUCT.LIST.FILTER.PRODUCT-NAME' | translate}} (TH)</label>
        </div>
      </div>
    </div>
    <div class="multiSelect-label-group">
      <p-multiSelect class="dv-multiSelect"
          selectId="department"
          [options]="departmentChoices"
          [(ngModel)]="departments"
          defaultLabel="{{'DEPARTMENT.LIST.FILTER.DEPARTMENT-NAME' | translate}}">
      </p-multiSelect>
    </div>
  </div>
  <div class="modal-footer m-b-0">
      <div class="col">
        <div class="row m-b-5">
          <div class="col text-center text-red">{{ errorMessage ? errorMessage : '&nbsp;' }}</div>
        </div>
        <div class="row justify-content-center">
          <div class="col">
            <button class="btn btn-dv btn-clean btn-wide m-r-20" (click)="close()">{{'COMMON.CANCEL' | translate}}</button>
          </div>
          <button class="col-auto btn btn-dv btn-wide pull-right" (click)="submit()">{{ (currentProduct ? 'PROFILE.LIST.MODAL.SAVE' : 'PROFILE.PASSWORD.CONFIRM') | translate }}</button>
        </div>
      </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product-list-detail/product-list-detail.component.html